import { useState, useEffect } from 'react';

type Props = {
  minutes: number;
};
export const useCountDown = ({ minutes }: Props) => {
  const [totalSeconds, setTotalSeconds] = useState(minutes * 60);

  useEffect(() => {
    const countdown = setInterval(() => {
      if (totalSeconds > 0) {
        setTotalSeconds(totalSeconds - 1);
      } else {
        clearInterval(countdown);
      }
    }, 1000);

    return () => clearInterval(countdown);
  }, [totalSeconds, minutes]);

  const hours = Math.floor(totalSeconds / 3600);
  const remainingSecondsAfterHours = totalSeconds % 3600;
  const calcMinutes = Math.floor(remainingSecondsAfterHours / 60);
  const seconds = remainingSecondsAfterHours % 60;

  const formatTime = (time: number): string => {
    return time < 10 ? `0${time}` : `${time}`;
  };

  return {
    hours: formatTime(hours),
    minutes: formatTime(calcMinutes),
    seconds: formatTime(seconds)
  };
};
